'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');let

AlertStatusCache=function(){
function AlertStatusCache(func){_classCallCheck(this,AlertStatusCache);
this._func=func;
this._map=new Map;
}AlertStatusCache.prototype.

get=function get(notificationType){
_.ensureInstanceOf(NotificationType,notificationType);

let status=this._map.get(notificationType);

if(!_.exists(status)){
status=this._func(notificationType);
this._map.set(notificationType,status);
}

return status;
};AlertStatusCache.prototype.

clear=function clear(){
this._map.clear();
};return AlertStatusCache}();


module.exports=AlertStatusCache;
//# sourceMappingURL=alertStatusCache.js.map
